import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import config from '@/config'
import 'font-awesome/css/font-awesome.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
      },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            dark: config.dark,
            light: config.light,
        }
    }
});